<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :before-close="closeDialog"
    append-to-body
    width="1000px"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="lang == 'zh' ? '选择用户': 'Select users'"
      @close="closeDialog"
    />
    <app-search >
      <div slot="content">
        <el-row  type="flex" justify="start" align="middle">
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="'80px'">
              <el-form-item :label="$t('public.userName')+'：'">
                <el-input v-model="listQuery.realName" :placeholder="$t('public.userName')" clearable />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="'90px'">
              <el-form-item :label="$t('public.mobile')+'：'">
                <el-input v-model="listQuery.mobile" filterable clearable :placeholder="$t('public.mobile')" />
              </el-form-item>
            </el-form>
          </el-col>

          <el-col :span="9">
            <el-form :label-position="'right'" :model="listQuery" :label-width="'100px'">
              <el-form-item  :label="$t('notice.isdisabled') + '：'">
                <el-radio-group v-model="listQuery.isDisabled">
                  <el-radio :label="''">
                    {{ $t('public.all') }}
                  </el-radio>
                  <el-radio :label="0">
                    {{ $t('public.enable') }}
                  </el-radio>
                  <el-radio :label="1">
                    {{ $t('public.ban') }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-col>
          
        </el-row>
      </div>
      <!-- 清空按钮 -->
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <el-table
      ref="tableList"
      show-overflow-tooltip
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @row-click="clickRow"
      @select="rowSelect"
      @select-all="selectAll"
      @sort-change="sortChange"
    >
      <el-table-column
        type="selection"
        width="55"
      />
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :min-width="item.width"
        :align="item.position"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
          
          <div v-if="item.prop==='isDisabled'">
            <span>{{ scope.row[item.prop] == 1 ? $t('public.ban'): $t('public.enable') }}</span>
          </div>
          <div v-else>
            <span >{{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="padding:10px 0" :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="headleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button type="primary" @click="submit()">{{ $t('public.define') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 混入
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
// request
import { getAppList } from '@/api/appManagement/notice'

export default {
  name: 'SelectCarDialog',
  filters: {
    carType(e) {
      switch (e) {
        case 1:
          return vm.$t('statistical.boxAddTask.forCar')
        case 2:
          return vm.$t('statistical.boxAddTask.ignites')
        case 3:
          return vm.$t('statistical.boxAddTask.standardCar')
      }
    }
  },
  mixins: [pagingMixin, otherHeight, tableStyle],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      listQuery: {isDisabled: ''},
      tableList: [
        // { value: this.$t('notice.user.loginName'), prop: 'loginName', width: '110px', position: 'center', checked: true },
        { value: this.$t('public.userName'), prop: 'realName', position: 'center', checked: true },
        { value: this.$t('appManagement.nickName'), prop: 'nickName', position: 'center', checked: true },
        { value: this.$t('public.mobile'), prop: 'mobile', position: 'center', checked: true },
        { value: this.$t('notice.user.disableOrNot'), prop: 'isDisabled', position: 'center', checked: true },
        { value: this.$t('public.createTime'), prop: 'createdOn', position: 'center', checked: true }
      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      selectList: []
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    },
    lang() {
      return this.$store.getters.language
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.selectList = [...this.data]
        this.listLoad()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight * 0.4
    })
    window.onresize = ()=> {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight * 0.4
      })
    }
  },
  methods: {
    restData() {
      this.handleClear()
      this.listQuery.pageNum = 1
      this.listQuery.pageSize = 10
    },
    // 关闭dialog
    closeDialog() {
      this.restData()
      this.$emit('update:visibles', false)
    },
    // 点击取消
    headleCancel() {
      this.closeDialog()
    },
    listLoad() {
      if (!this.visibles) {
        return
      }
      this.listLoading = true
      getAppList(this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data || []
          this.total = data.total
          this.$nextTick(() => {
            for (let i = 0; i < this.list.length; i++) {
              this.data.forEach((r) => {
                if (this.list[i].appUserId === r.appUserId) {
                  this.$refs.tableList.toggleRowSelection(this.list[i])
                }
              })
            }
          })
          const orderSort = 'licensePlate,brandName,modelName,seriesName'
          this.setOrderField(orderSort, this.tableList)
        }
        this.listLoading = false
      })
    },
    rowSelect(selection, row) {
      const index = this.selectList.findIndex(item => item.appUserId === row.appUserId)
      if (index > -1) {
        this.selectList.splice(index, 1)
      } else {
        this.selectList.push(row)
      }
    },
    selectAll(selection) {
      // 此时反选
      if (selection.length === 0) {
        for (let i = 0; i < this.list.length; i++) {
          const index = this.selectList.findIndex(item => item.appUserId === this.list[i].appUserId)
          if (index > -1) {
            this.selectList.splice(index, 1)
          }
        }
      } else {
        this.selectList = []
        this.selectList = [...this.list]
      }
    },

    clickRow(row) {
      const index = this.selectList.findIndex(item => item.appUserId === row.appUserId)
      if (index > -1) {
        this.selectList.splice(index, 1)
      } else {
        this.selectList.push(row)
      }
      this.$refs.tableList.toggleRowSelection(row)
    },
    // 提交按钮
    submit() {
      this.$emit('select-complete', this.selectList)
      this.closeDialog()
    }

  }
}

</script>

<style lang="scss" scoped>
.search_list{
  padding-top:0
}
.el-radio{
  margin-right: 10px;
}
.el-radio__label{
  padding-left: 5px;
}
</style>
